import {
  OperatorEquals,
  OperatorExactlyAllOf,
  OperatorExactlyAnyOf,
  OperatorExcludeAllOf,
  OperatorExcludeAnyOf,
  OperatorForAllOf,
  OperatorForAnyOf,
  OperatorIsAllOf,
  OperatorIsAnyOf,
  OperatorIsNotAnyOf,
  OperatorIsNotPresent,
  OperatorIsPresent,
  OperatorNot,
  OperatorNotEquals,
} from 'v2/core/services/queryBuilder/operators';
import {
  FilterUnion,
  OperationType,
} from 'v2/core/services/queryBuilder/whereClause';
import checkIsExactSearchFilter from 'v2/core/utils/checkIsExactSearchFilter';
import operatorFromSentiment from './operatorFromSentiment';

export function operatorFromFilter(filter: FilterUnion, exclude?: boolean) {
  if (filter.entityFilter && filter.entityFilter.entities?.[0]?.sentiment) {
    return operatorFromSentiment(filter.entityFilter.entities?.[0]?.sentiment);
  }

  if (filter.hybridSearchFilter) {
    if (
      filter.hybridSearchFilter.queries &&
      checkIsExactSearchFilter(filter.hybridSearchFilter.queries)
    ) {
      if (filter.type === OperationType.AND) {
        return OperatorExactlyAllOf;
      }
      return OperatorExactlyAnyOf;
    }
    if (filter.type === OperationType.AND) {
      return exclude ? OperatorExcludeAllOf : OperatorForAllOf;
    }
    return exclude ? OperatorExcludeAnyOf : OperatorForAnyOf;
  }

  const isTaxonomyFilter =
    filter.entityFilter ||
    filter.reasonFilter ||
    filter.labelHierarchyFilter ||
    filter.l1Filter;

  if (isTaxonomyFilter) {
    if (exclude) {
      return OperatorNot;
    }
    if (filter.type === OperationType.AND) {
      return OperatorIsAllOf;
    }
    return OperatorIsAnyOf;
  }

  if (
    filter.hasReasonFilter ||
    filter.hasAspectFilter ||
    filter.hasUserContentFilter ||
    filter.hasSummaryFilter ||
    filter.hasMetadataFilter
  ) {
    if (exclude) {
      return OperatorIsNotPresent;
    }
    return OperatorIsPresent;
  }

  if (filter.reviewSentimentFilter) {
    if (exclude) {
      return OperatorIsNotAnyOf;
    }
    return OperatorIsAnyOf;
  }

  if (filter.sourceFilter) {
    if (exclude) {
      return OperatorIsNotAnyOf;
    }
    return OperatorIsAnyOf;
  }

  if (filter.categoryFilter) {
    if (exclude) {
      return OperatorIsNotAnyOf;
    }
    return OperatorIsAnyOf;
  }

  if (filter.languageFilter) {
    return exclude ? OperatorIsNotAnyOf : OperatorIsAnyOf;
  }

  if (filter.metadataFilter?.operator) {
    return filter.metadataFilter?.operator;
  }

  if (exclude) {
    return OperatorNotEquals;
  }

  return OperatorEquals;
}
